import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const EditIncentiveType = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [material, setMaterial] = useState([])

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    const response = await api.get("incentive-type/" + id)
    const data = response.data.data
    setMaterial(Array.isArray(data) ? data[0] : data)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const updateUnit = await api.put("update-incentive-type/" + id, values)
    if (updateUnit.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit Additional Incentive Type</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/incentive-types" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <div className="mb-3">
              <AvField
                name="incentive_type"
                label="Additional Incentive Type Name"
                value={material.incentive_type}
                className="form-control"
                placeholder="Enter Additional Incentive Type Name"
                type="text"
                required
              />
            </div>
            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Additional Incentive Type is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditIncentiveType
